import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getObjectListApi } from "api/general";
import { UNITS } from "app/utils/constants/customConstant";




const initialState = {
    data: [],
};

export const getUnitAPI = createAsyncThunk("getUnitAPI", async (thunkAPI) => {
    try {

        const res = await getObjectListApi(UNITS);
        return res.data;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }

})



const unit = createSlice({
    name: "unit",
    initialState,
    reducers: {
        setUnitData: (state, action) => {
            state.data = action.payload;
        },
        getUnitFetchData: (state, action) => {
            state.data = action.payload;
        }


    },
    extraReducers: (builder) => {
        builder
            .addCase(getUnitAPI.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getUnitAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.data = action.payload;
            })
            .addCase(getUnitAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.authUnit = null;
            })

    }
});

export const { setUnitData, getUnitFetchData } = unit.actions;
export default unit.reducer;